export class Portal {

    // Static Properties
    static NewPortalID = 1000;

	// Server Properties
	$id: string | null;
	AnnouncementsOnly: boolean;
	Deleted: boolean | null;
	Disabled: boolean | null;
	DisabledMessage: string | null;
	IconType: any | null;
	Id: number | null;
	IsLive: boolean | null;
	IsMyLinksTile: boolean | null;
	Favorite: boolean | null;
	OpenInNewWindow: boolean | null;
	ParentId: number | null;
	ParentPortal: boolean;
	PortalDescription: string | null;
	PortalName: string | null;
	ShowAsMenu: boolean | null;
	ShowAsTile: boolean | null;
	ShowonCurrentYear: boolean | null;
	ShowonFutureYear: boolean | null;
	ShowonPastYear: boolean | null;
	TileAddedOn: Date | null;
	TileColor: any | null;
	TileIcon: any | null;
	TileImageFile: any | null;
	TileOrder: number | null;
	TileType: any | null;
	TransportationYear: any | null;
	ShowIcon: boolean | null;
	Selected = false;
	GroupName: string | null;
	MenuIcon: string | null;
	MenuDisabledIcon: string | null;
    GroupIcon: string | null;
	Student_ID: number;
	IsFavorite = false;
	GroupNameFavorite: string | null;
	NoSchoolPolicy: boolean;
	RequiredPrivilegeIDs: number[];

	// Non DTO Fields:
	innerHTML: string;
	ParentModule: string;
	TileFontColor: string;

	// Local Properties
	applyFilterStudents = false;
	isDefaultSelected = false;
	Expanded = 1;
    IsGroup = false;
    ChildPortals: Portal[];

    // Constructor
    constructor(portalName?: string) {
        this.PortalName = portalName ?? '';
        this.ShowAsMenu = true;
        this.Deleted = false;
        this.ChildPortals = [];
        this.Id = Portal.NewPortalID;
        Portal.NewPortalID += 1;
    }
}
